import { useState } from 'react';

// This line imports the 'useState' hook from the 'react' library.

const useLocalStorage = (key, initialValue) => {
  // This function 'useLocalStorage' is a custom hook that interacts with the browser's localStorage.
  // It takes a 'key' and 'initialValue' as parameters.

  const [storedValue, setStoredValue] = useState(() => {
    // This line initializes the 'storedValue' state using the 'useState' hook.
    // It attempts to retrieve an item from localStorage based on the provided 'key'.
    // If the item exists, it parses and returns it; otherwise, it returns the 'initialValue'.

    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    // This function 'setValue' is used to update the stored value in localStorage.
    // It takes a 'value' parameter and handles the update process.

    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      // This line determines the 'valueToStore' based on whether 'value' is a function or not.
      // If 'value' is a function, it is called with the current 'storedValue'.

      setStoredValue(valueToStore);
      // This line updates the 'storedValue' state with the new value.

      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      // This line stores the updated value in localStorage after converting it to a string.
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
  // This line returns an array containing the 'storedValue' and 'setValue' function.
};

export default useLocalStorage;
